import { render, staticRenderFns } from "./removeImg.vue?vue&type=template&id=4e5ed4ea&scoped=true&"
import script from "./removeImg.vue?vue&type=script&lang=js&"
export * from "./removeImg.vue?vue&type=script&lang=js&"
import style0 from "./removeImg.vue?vue&type=style&index=0&id=4e5ed4ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5ed4ea",
  null
  
)

export default component.exports